/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Sheet_Report_Reason_NameInputs */

const en_us2_exercise_sheet_report_reason_name = /** @type {(inputs: Exercise_Sheet_Report_Reason_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

const pt_br2_exercise_sheet_report_reason_name = /** @type {(inputs: Exercise_Sheet_Report_Reason_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome`)
};

const es_419_exercise_sheet_report_reason_name = /** @type {(inputs: Exercise_Sheet_Report_Reason_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre`)
};

const pt_pt2_exercise_sheet_report_reason_name = /** @type {(inputs: Exercise_Sheet_Report_Reason_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome`)
};

const fr_fr2_exercise_sheet_report_reason_name = /** @type {(inputs: Exercise_Sheet_Report_Reason_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom`)
};

const de_de2_exercise_sheet_report_reason_name = /** @type {(inputs: Exercise_Sheet_Report_Reason_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

const it_it2_exercise_sheet_report_reason_name = /** @type {(inputs: Exercise_Sheet_Report_Reason_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome`)
};

/**
* | output |
* | --- |
* | "Name" |
*
* @param {Exercise_Sheet_Report_Reason_NameInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_report_reason_name = /** @type {((inputs?: Exercise_Sheet_Report_Reason_NameInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_Report_Reason_NameInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_report_reason_name(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_report_reason_name(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_report_reason_name(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_report_reason_name(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_report_reason_name(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_report_reason_name(inputs)
	return en_us2_exercise_sheet_report_reason_name(inputs)
});
export { exercise_sheet_report_reason_name as "exercise-sheet.report_reason_name" }